import { render, staticRenderFns } from "./Email-compose.vue?vue&type=template&id=72a62af2&"
import script from "./Email-compose.vue?vue&type=script&lang=js&"
export * from "./Email-compose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports